import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';

import { Store } from '@ngrx/store';
import { AuthService } from '@app/core/services';
import * as fromAuth from '@app/core/store/auth';


@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate, CanActivateChild {

  constructor(
    private store: Store<fromAuth.AuthState>,
    private router: Router, private auth: AuthService) {
      
    }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
      let url = state.url;
      this.auth.redirectUrl = url;
  
      try{
        return this.auth.getCurrentUser().then(user => {
          if(user.rol == 'admin' || user.rol == 'superadmin'){
            return true;
          }else{
            this.router.navigate(['/auth/forbidden']);
            return false;
          }
        });
      }catch(error){
          console.error("Error filtro pages", error);
          this.router.navigate(['/auth/forbidden']);        
      }
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    
      let url = state.url;
      this.auth.redirectUrl = url;
  
      try{
        return this.auth.getCurrentUser().then(user => {
          if(user.rol == 'admin' || user.rol == 'superadmin'){
            return true;
          }else{
            this.router.navigate(['/auth/forbidden']);
            return false;
          }
        });
      }catch(error){
          console.error("Error filtro pages", error);
          this.router.navigate(['/auth/forbidden']);        
      }
  }
}
